import React from "react";
import "../App.css";
import {
  FaInstagram,
  FaFacebook,
  FaSoundcloud,
  FaTwitter,
} from "react-icons/fa";

import Blinded4 from "../images/blinded4.jpg";

function Blinded() {
  return (
    <div id="top__page">
      <div className="flex__layout">
        <div className="artist__description" data-aos="fade-down">
          <h1>Blinded Hearts</h1>
          <br />
          <h3>Producer / Songwriter / Artist</h3>
          <br />
          <p>
            2021 was truly a successful year for Blinded Hearts. With 15 singles
            and a remix package incl. acoustic version of "So Done“, he has
            emphatically manifested and developed his sound. With his unique mix
            of elements from different electronic genres, he has only one
            ambition: to create emotions.
          </p>
          <br />
          <p>
            And in doing so, he relies on collaborations with other producers
            such as Lucas Estrada, Paradigm, Matvey Emerson and Jake Cooper, to
            name a few. These originals, covers and remixes were toplined by no
            other than Philip Strand, Jay Mason, Séb Mont, Marmy, Henrik Hoven
            and Natascha Bessez.
          </p>
          <br />
          <p>
            With editorial placements across all major streaming platforms and
            the support of international superstars like Hardwell, Don Diablo,
            Sam Feldt and Nicky Romero, Blinded Hearts is ready to go for 2022
            and do what he loves most: Music. Cause that´s what it´s all about.
          </p>

          <br />
          <div className="social__media__icons">
            <li>
              <a
                href="https://www.instagram.com/blinded_hearts/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaInstagram fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a href="#" rel="noopener noreferrer">
                <p>
                  <FaFacebook fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a href="#" rel="noopener noreferrer">
                <p>
                  <FaTwitter fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a href="#" rel="noopener noreferrer">
                <p>
                  <FaSoundcloud fill="white" size={40} />
                </p>
              </a>
            </li>
          </div>
        </div>

        {/*Photos or Videos + playlist.*/}
        <div>
          <div className="__photos" data-aos="fade-up">
            <img
              src={Blinded4}
              className="artists__photo__size"
              className="artists__photo__size"
            />
          </div>
        </div>
      </div>

      <div className="spotify__playlist" data-aos="fade-right">
        <iframe
          src="https://open.spotify.com/embed/playlist/48WJK3SUDIQEoLN30OsplC?utm_source=generator&theme=0"
          width="800"
          height="380"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        ></iframe>
      </div>
    </div>
  );
}

export default Blinded;
